import { Select } from '@components/form';
import { MenuItem } from '@mui/material';
import { useField } from 'formik';

const StorageSizeOptions: Record<number | string, string | number> = {
  300: 'Small - 300 GB',
  512: 'Medium - 500 GB',
  1024: 'Large - 1 TB',
};

type StorageSizeSelectorProps = {
  name: string;
  label: string;
  labelInfo?: string;
};

export const StorageSizeSelector = ({ name, label, labelInfo }: StorageSizeSelectorProps) => {
  const [field, , helpers] = useField(name);
  return (
    <Select
      label={label}
      labelInfo={labelInfo}
      value={field.value as number}
      maintainGutters
      onChange={(e) => {
        const selection = e.target.value as number;
        void helpers.setValue(selection);
      }}
    >
      {Object.entries(StorageSizeOptions).map(([key, value]) => (
        <MenuItem key={key} value={Number(key)}>
          {value}
        </MenuItem>
      ))}
    </Select>
  );
};
